import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { ElevesView } from '@teetsh/app/src/types/eleves';
import { ELEVES_VIEWS_KEY } from '@teetsh/app/src/queries/eleves/views/useElevesViews';
import serializeFilter from '@teetsh/app/src/queries/eleves/views/serializeFilter';

function updateEleveView(props: {
  schoolyearId: string;
  schoolId: string;
  view: ElevesView;
}) {
  const view = props.view;
  const requestURL = `/schoolyears/${props.schoolyearId}/schools/${props.schoolId}/eleves-views/${view.id}`;
  return request(requestURL, {
    method: 'PATCH',
    body: {
      id: view.id,
      name: view.name,
      fields: view.fields,
      filters: view.filters && serializeFilter(view.filters),
    },
  });
}

export default function useUpdateElevesView() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: (view: ElevesView) =>
      updateEleveView({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        view,
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ELEVES_VIEWS_KEY],
      });
    },
  });
  return mutateAsync;
}
